import React from "react";
import { Button, Card } from "react-bootstrap";
import { findIcon } from "views/dashboard/icons";

const TableHeader = ({
  title = "",
  leftComponent = <></>,
  searchProps = {
    isNeeded: false,
    placeholder: "",
    searchText: "",
    setSearchText: () => {},
  },
  downloadProps = {
    needCsvDownload: false,
    needImgDownload: false,
    exportCSVHandler: () => {},
    downloadImageHandler: () => {},
  },
  alignmentEnd = false,
  cardHeaderClass = "",
}) => {
  return (
    <Card.Header
      className={`d-flex ${
        alignmentEnd ? "justify-content-end" : "justify-content-between"
      }  flex-wrap gap-3 align-items-md-center ${cardHeaderClass}`}
    >
      {!!title && (
        <div className="d-flex align-items-center">
          <h5 className="subHeadingLeft position-relative m-0">{title}</h5>
        </div>
      )}

      {leftComponent}

      <div className="d-flex justify-content-end flex-wrap align-items-center gap-sm-3 gap-2">
        {searchProps.isNeeded && (
          <div className="position-relative d-sm-block d-none mw-100 w-300px table-header__search">
            <div
              className="position-absolute top-50 start-0 translate-middle-y ms-3"
              style={{ pointerEvents: "none" }}
            >
              {findIcon("Search", "outline", "24")}
            </div>

            <input
              className="form-control rounded-5 ps-6"
              type="search"
              placeholder={searchProps.placeholder}
              aria-label="Search"
              value={searchProps.searchText}
              onChange={(e) => searchProps.setSearchText(e.target.value)}
            />
          </div>
        )}
        {downloadProps.needImgDownload || downloadProps.needCsvDownload ? (
          <div className="d-flex flex-row justify-content-end gap-2 flex-shrink-0">
            {downloadProps.needImgDownload && (
              <Button
                variant="soft-primary"
                className="d-flex gap-2 align-items-center rounded-2 text-nowrap"
                onClick={downloadProps.downloadImageHandler}
                size="sm"
              >
                {findIcon("Document Arrow Down", "dual-tone", "20")}
                <span className="d-none d-md-inline-block">Download</span>
              </Button>
            )}

            {downloadProps.needCsvDownload && (
              <Button
                variant="soft-success"
                className="d-flex gap-2 align-items-center rounded-2 text-nowrap"
                onClick={downloadProps.exportCSVHandler}
                size="sm"
              >
                {findIcon("export", "dual-tone", "20")}
                <span className="d-none d-md-inline-block">Export</span>
              </Button>
            )}
          </div>
        ) : null}
      </div>

      {searchProps.isNeeded && (
        <div className="position-relative d-sm-none mt-2 d-block w-100 table-header__search">
          <div
            className="position-absolute top-50 start-0 translate-middle-y ms-3"
            style={{ pointerEvents: "none" }}
          >
            {findIcon("Search", "outline", "24")}
          </div>

          <input
            className="form-control rounded-5 ps-6"
            type="search"
            placeholder={searchProps.placeholder}
            aria-label="Search"
            value={searchProps.searchText}
            onChange={(e) => searchProps.setSearchText(e.target.value)}
          />
        </div>
      )}
    </Card.Header>
  );
};

export default TableHeader;
